export default [
    {
        path: "/clients",
        name: "clients",
        component: require("../components/modules/client/ClientList.vue")
            .default
    },
    {
        path: "/clients/new",
        name: "new client",
        component: require("../components/modules/client/ClientCard.vue")
            .default
    },
    {
        path: "/clients/:id",
        name: "client",
        component: require("../components/modules/client/ClientCard.vue")
            .default,
        props: true
    }
];
